import axios from 'axios';
import { store } from 'store';
import { ENDPOINTS } from './endpoints';

let API;

if (process.env.NODE_ENV === 'development') {
  API = axios.create({
    baseURL: `http://${process.env.REACT_APP_SERVICES_USER_ADDRESS}:${process.env.REACT_APP_SERVICES_USER_PORT}/`,
  });
} else {
  API = axios.create({
    baseURL: `${process.env.REACT_APP_FRONTEND_URL}/user/`,
  });
}

API.interceptors.request.use(
  (config) => {
    const { isOnline } = store.getState().platform;

    if (!isOnline) {
      return Promise.reject(
        new axios.Cancel('Request blocked: No Internet Connection')
      );
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const doesEmailExist = (payload) =>
  API.post(ENDPOINTS.email_availability, payload);

const doesUserNameExist = (username) =>
  API.get(ENDPOINTS.username_availability(username));

const getTrialHeader = () =>
  API.post(ENDPOINTS.get_trial_header);

const googleOAuth = (payload, token) => {
  const config = {};

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return API.post(ENDPOINTS.google_oauth, payload, config);
};

const initiateForgotPassword = (payload) =>
  API.post(ENDPOINTS.initiate_forgot_password, payload);

const passwordChangeOrReset = (token, payload) =>
  API.post(ENDPOINTS.change_password, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });

const updateUserDetails = (token, payload) =>
  API.post(ENDPOINTS.update_user_details, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });

const userSignIn = (payload) => API.post(ENDPOINTS.sign_in, payload);

const userSignUp = (payload, token) => {
  const config = {};

  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return API.post(ENDPOINTS.sign_up, payload, config);
};


const userTrialMode = (headerKey) => API.post(ENDPOINTS.sign_up, {}, {
  headers: { 'x-trial-key': headerKey },
});

const verifyEmail = (token) => API.get(ENDPOINTS.verify_email(token));

export {
  doesEmailExist,
  doesUserNameExist,
  getTrialHeader,
  googleOAuth,
  initiateForgotPassword,
  passwordChangeOrReset,
  updateUserDetails,
  userSignIn,
  userSignUp,
  userTrialMode,
  verifyEmail,
};